<template>
  <span :class="primitiveBaseClasses">
    <div class="custom-control custom-checkbox">
        <input type="checkbox" class="form-control custom-control-input"
            :id="'checkbox-'+id" :title="label" v-model="internalChecked" :disabled="$_disabled">
        <label class="custom-control-label" :for="'checkbox-'+id">{{label}}</label>
        <div class="error-div">
            {{validationMessage}}
        </div>
    </div>
  </span>
</template>

<script>
import primitiveMixin from './primitive-mixin'
import { v } from "framework";

export default {
    mixins:[primitiveMixin],
    props:  {
        label: {
            type: String,
            required: true
        },
        value: {
            required: true,
            validator: v => {
                if (v === null) return true;
                if (_.isBoolean(v)) return true;
                if (_.isString(v)) return v === "true" || v === "false";
            }
        },
    },
    data() {
        return {
            id: Math.random().toString().replace(".", ""),
            internalChecked: this.value,
        }
    },
    watch: {
        value(newValue) {
            if (_.isString(newValue)) 
                this.internalChecked = newValue = (newValue === "true");
            else if (newValue === null)
                this.internalChecked = false;
            else
                this.internalChecked = newValue;
        },
        internalChecked(newValue) {
            this.changeMade({ name: this.label, value: this.internalChecked });
            this.$emit("input", newValue);
        },
    },
    methods: {
    },
    computed: {
    },
}
</script>

<style lang="scss">
.custom-control-label::before {
    border-top: 1px solid #CCC;
    border-right: 1px solid #AAA;
    border-bottom: 1px solid #AAA;
    border-left: 1px solid #CCC;
}
.custom-control-input:checked~.custom-control-label::before, 
.custom-control-input:disabled~.custom-control-label::before {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfCheckbox.vue